import { render, staticRenderFns } from "./CommonContentGroup.vue?vue&type=template&id=54b254e6"
import script from "./CommonContentGroup.vue?vue&type=script&lang=js"
export * from "./CommonContentGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports